import { commonUtils } from '../common_utils';

export const opSeller = {
    removeGreenEffect() {
        $('.greenFadeEffectOps').removeClass('updateSec');
    },
    loadYear(defaultYears) {
        $('#opsLoanPeriod').empty();
        let loanAmount = $('#opsLoanAmount').val();
        let startYear = 1;
        let siteWiseMaxPriceForTarkkaluotto = 30000;
        let endYear = loanAmount > siteWiseMaxPriceForTarkkaluotto ? 10 : 20;
        for (let year = startYear; year <= endYear; year++) {
            $('#opsLoanPeriod').append(new Option(year, year * 12));
        }

        $('#opsLoanPeriod').val(defaultYears);
    },
    slider() {
        let defaultYear = $('#opsLoanPeriod').val();
        let loanAmount = $('#opsLoanAmount').val();
        let bankName = $('#opSellerLoan').data('bank-name');
        let autoMaxPrice = 'OpPankkilaina' === bankName ? 200000 : 30000;
        let opSellerMinLoanAmount = 2000;
        let opSellerMaxLoanAmount = autoMaxPrice;

        $('.greenFadeEffectOps').addClass('updateSec');

        if (loanAmount < opSellerMinLoanAmount) {
            alert(`${Translations.ad_detail.finance.error.op_min_amount + opSellerMinLoanAmount}€`);
            loanAmount = opSellerMinLoanAmount;
            $('#opsLoanAmount').val(loanAmount);
        }

        if (loanAmount > opSellerMaxLoanAmount) {
            alert(`${Translations.ad_detail.finance.error.op_max_amount + opSellerMaxLoanAmount}€`);
            loanAmount = opSellerMaxLoanAmount;
            $('#opsLoanAmount').val(loanAmount);
        }

        opSeller.loadYear(defaultYear);
        defaultYear = $('#opsLoanPeriod').val();

        $.ajax({
            type: 'GET',
            url: Routing.generate('finance_op_seller'),
            data: `loanAmount=${loanAmount}&loanPeriod=${defaultYear}`,
            success(data) {
                let loanData = data.opSeller;
                let installment = '-',
                    effective = '-',
                    nominal = '-';
                if (loanData) {
                    installment = commonUtils.numberFormatByLocale(loanData.monthlyPayment.toFixed(2));
                    effective = commonUtils.numberFormatByLocale(loanData.annualInterest.toFixed(2));
                    nominal = commonUtils.numberFormatByLocale(loanData.interest.toFixed(2));
                }

                $('#ops_monthly_payment').html(installment);
                $('#ops_air').html(effective);
                $('#ops_mir').html(nominal);

                setTimeout(opSeller.removeGreenEffect, 1000);
            },
        });
    },
    submit(object) {
        commonUtils.dataLayer.getLoanButtonDataLayerEvent(object.data('bank-name'));

        let loanAmount = $('#opsLoanAmount').val();
        let loanPeriod = $('#opsLoanPeriod').val();
        let loanUrl = `${$('#opSellerLink').data('loan-url')}&amount=${loanAmount}&tenor=${loanPeriod}`;
        window.open(loanUrl, '_blank');
    },
};
